module.exports = __webpack_public_path__ + "cd0c085a0eafd74ccdf47d7137e8fc9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/new_york_times_2023_chart.png
// module id = 1703
// module chunks = 0